"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionSymbolAddressMappings = void 0;
exports.CollectionSymbolAddressMappings = {
    'JSSTORY': '0x8567F048c9873887BBC17978666E55C6ec66D148',
    'CPBAYC': '0x79ffBdA9E610dE996B86bd14d24E5726573dB634',
    'FP': '0x8c2220db0CCB009Da045744e40e1aCF54A51a478' // founders pass
};
//# sourceMappingURL=collectionSymbolAddressMappings.js.map